import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { cancelReturn } from "../../api/apiReturns";
import parseError from "../../utils/parseError";

export const useCancelReturn = () => {
    const queryClient = useQueryClient();

    const { mutate: cancelReturnMutate, isPending: isCancelling } = useMutation({
        mutationFn: ({ id, data }) => cancelReturn(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Return cancelled");
            queryClient.invalidateQueries(["returns"]);
            queryClient.invalidateQueries(["return"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to cancel return");
        },
    });

    return { cancelReturnMutate, isCancelling };
};
